import { Skeleton, SkeletonBadge, SkeletonCard } from 'shared/components/ui/Skeleton';

// Espelha <AgendaItemCard>: tipo, título, local, data à direita e rodapé do prazo de cancelamento.
export function AgendaItemSkeleton() {
  return (
    <SkeletonCard className="flex flex-col gap-3 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1">
          <SkeletonBadge className="w-14" />
          <Skeleton className="mt-3 h-4 w-44" />
          <Skeleton className="mt-2 h-3 w-36" />
        </div>
        <div className="flex flex-col items-end gap-2">
          <Skeleton className="h-3.5 w-12" />
          <Skeleton className="h-3 w-10" />
        </div>
      </div>
      <div className="flex justify-between">
        <Skeleton className="h-2.5 w-40" />
        <Skeleton className="h-2.5 w-12" />
      </div>
    </SkeletonCard>
  );
}
